import React, { useState } from 'react';
import { AudioRecorder } from 'react-audio-voice-recorder';

import { Button } from '@mui/material';
import Async from 'components/Async';

import { postMedia } from '@common/api/media';

import { StyledRecordWrap, StyledRecorderPlayerWrap } from './styled';

interface RecorderProps {
	value: string | null;
	onAudioRecord: (blob: null | string) => void;
	hideDeleteButton?: boolean;
}

function Recorder({ value, onAudioRecord, hideDeleteButton, ...props }: RecorderProps) {
	const [isLoading, setIsLoading] = useState(false);

	const addAudioElement = async (blob: Blob) => {
		setIsLoading(true);
		try {
			const response = await postMedia(blob);
			if (response.url) {
				onAudioRecord(response.url);
			}
		} catch (e) {
			console.error(e);
		} finally {
			setIsLoading(false);
		}
	};

	const handleDeleteAudio = () => {
		onAudioRecord(null);
	};

	return (
		<StyledRecordWrap>
			<Async loading={isLoading}>
				{!value ? (
					<AudioRecorder
						audioTrackConstraints={{
							noiseSuppression: true,
							echoCancellation: true,
						}}
						showVisualizer
						onRecordingComplete={addAudioElement}
						{...props}
					/>
				) : (
					<>
						<StyledRecorderPlayerWrap>
							<audio src={value} controls>
								<track kind="captions" />
							</audio>
						</StyledRecorderPlayerWrap>
						{!hideDeleteButton && (
							<Button onClick={handleDeleteAudio} variant="contained">
								Delete Audio
							</Button>
						)}
					</>
				)}
			</Async>
		</StyledRecordWrap>
	);
}

export default Recorder;
